import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectWithoutProperties from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { Chip, createStyles, FormControl, MenuItem, Paper, TextField, Typography, withStyles } from '@material-ui/core';
import Select, { components as SelectComponents } from 'react-select';
import { ArrowDropDown } from '@material-ui/icons';
import CloseIcon from 'mdi-react/CloseIcon';
import classnames from 'classnames';

var styles = function styles(theme) {
  return createStyles({
    root: {
      flexGrow: 1,
      height: 250,
      minWidth: 290
    },
    input: {
      display: 'flex',
      padding: 0,
      paddingRight: 2,
      minHeight: 29,
      height: 'auto'
    },
    inputSlim: {
      minHeight: 18
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden'
    },
    valueContainerSlim: {
      minHeight: 18,
      fontSize: 12
    },
    chip: {
      margin: theme.spacing(0.5, 0.25),
      height: 'auto',
      fontSize: 12,
      borderRadius: 4
    },
    chipFocused: {// backgroundColor: emphasize(
      //   theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      //   0.08,
      // ),
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    singleValue: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      bottom: 6,
      fontSize: 14
    },
    paper: {
      position: 'absolute',
      zIndex: 100,
      marginTop: theme.spacing(0.5),
      left: 0,
      right: 0
    },
    paperTop: {
      bottom: 'calc(100% + 8px)',
      marginTop: 0
    },
    divider: {
      height: theme.spacing(2)
    },
    formControl: {
      margin: 0,
      '& > div': {
        marginTop: 0,
        marginBottom: 0
      }
    },
    error: {
      marginTop: 0
    },
    caretIcon: {
      color: 'inherit',
      opacity: 0.7
    },
    caretIconSlim: {
      height: 18,
      width: 18
    },
    chipLabel: {
      whiteSpace: 'normal',
      lineHeight: 1.2,
      padding: '4px 8px'
    },
    searchInputSlim: {
      height: 15
    }
  });
};

var indicatorSeparator = function indicatorSeparator(provided) {
  return _objectSpread({}, provided, {
    marginTop: 0,
    marginBottom: 0,
    background: 'transparent'
  });
};

var customStyles = {
  indicatorSeparator: indicatorSeparator,
  menuPortal: function menuPortal(base) {
    return _objectSpread({}, base, {
      zIndex: 9999
    });
  },
  input: function input(base) {
    return _objectSpread({}, base, {
      color: 'inherit'
    });
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread({}, base, {
      cursor: 'pointer'
    });
  }
};

var DropdownIndicator = function DropdownIndicator(props) {
  var _props$selectProps = props.selectProps,
      classes = _props$selectProps.classes,
      slim = _props$selectProps.slim;
  return React.createElement(ArrowDropDown, {
    className: classnames(classes.caretIcon, _defineProperty({}, classes.caretIconSlim, slim)),
    fontSize: slim ? 'small' : 'default'
  });
};

var Input = function Input(props) {
  if (props.isHidden) {
    return React.createElement(SelectComponents.Input, Object.assign({}, props));
  }

  return React.createElement(SelectComponents.Input, Object.assign({}, props, {
    className: props.selectProps.classes.searchInputSlim
  }));
};

function NoOptionsMessage(props) {
  return React.createElement(Typography, Object.assign({
    color: 'textSecondary',
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
}

function SelectContainer(props) {
  var children = props.children,
      innerProps = props.innerProps,
      classes = props.selectProps.classes;
  return React.createElement(FormControl, Object.assign({
    fullWidth: true,
    margin: 'dense',
    variant: 'outlined',
    className: classes.formControl
  }, innerProps), children);
}

function Control(props) {
  var children = props.children,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      hasValue = props.hasValue,
      isFocused = props.isFocused,
      _props$selectProps2 = props.selectProps,
      classes = _props$selectProps2.classes,
      TextFieldProps = _props$selectProps2.TextFieldProps,
      slim = _props$selectProps2.slim;
  return React.createElement(TextField, Object.assign({
    fullWidth: true,
    margin: 'dense',
    InputProps: {
      inputComponent: inputComponent,
      inputProps: _objectSpread({
        className: classnames(classes.input, _defineProperty({}, classes.inputSlim, slim)),
        ref: innerRef,
        children: children
      }, innerProps)
    },
    InputLabelProps: {
      shrink: hasValue || isFocused
    }
  }, TextFieldProps));
}

function Option(props) {
  return React.createElement(MenuItem, Object.assign({
    ref: props.innerRef,
    selected: props.isFocused,
    component: 'div',
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps, {
    dense: true
  }), props.children);
}

function Placeholder(props) {
  var selectProps = props.selectProps,
      _props$innerProps = props.innerProps,
      innerProps = _props$innerProps === void 0 ? {} : _props$innerProps,
      children = props.children;
  return React.createElement(Typography, Object.assign({
    color: 'textSecondary',
    className: selectProps.classes.placeholder
  }, innerProps), children);
}

function SingleValue(props) {
  return React.createElement(Typography, Object.assign({
    className: props.selectProps.classes.singleValue
  }, props.innerProps), props.children);
}

function ValueContainer(props) {
  var children = props.children,
      _props$selectProps3 = props.selectProps,
      classes = _props$selectProps3.classes,
      slim = _props$selectProps3.slim;
  return React.createElement("div", {
    className: classnames(classes.valueContainer, _defineProperty({}, classes.valueContainerSlim, !!slim))
  }, children);
}

function MultiValue(props) {
  return React.createElement(Chip, {
    tabIndex: -1,
    label: props.children,
    classes: {
      label: props.selectProps.classes.chipLabel
    },
    className: "".concat(props.selectProps.classes.chip, " ").concat(props.isFocused ? props.selectProps.classes.chipFocused : ''),
    onDelete: props.removeProps.onClick,
    deleteIcon: React.createElement(CloseIcon, {
      size: 6
    })
  });
}

function Menu(props) {
  var innerRef = props.innerRef,
      children = props.children,
      classes = props.selectProps.classes,
      innerProps = props.innerProps,
      placement = props.placement;
  return React.createElement(Paper, Object.assign({
    square: true,
    className: "".concat(classes.paper, " ").concat(placement === 'top' ? classes.paperTop : '')
  }, innerProps, {
    ref: innerRef
  }), children);
}

var components = {
  // Input,
  Control: Control,
  Menu: Menu,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer,
  SelectContainer: SelectContainer,
  DropdownIndicator: DropdownIndicator
}; // todo Доработать стили для slim варианта

var AutoComplete =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AutoComplete, _React$Component);

  function AutoComplete() {
    _classCallCheck(this, AutoComplete);

    return _possibleConstructorReturn(this, _getPrototypeOf(AutoComplete).apply(this, arguments));
  }

  _createClass(AutoComplete, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          value = _this$props.value,
          options = _this$props.options,
          onChange = _this$props.onChange,
          isMulti = _this$props.isMulti,
          slim = _this$props.slim;
      return React.createElement(Select, {
        classes: classes,
        styles: customStyles,
        placeholder: '',
        options: options,
        components: components,
        value: value,
        onChange: onChange,
        isMulti: isMulti,
        menuPortalTarget: document.body,
        menuPosition: 'absolute',
        menuPlacement: 'auto',
        isClearable: !isMulti,
        slim: slim
      });
    }
  }]);

  return AutoComplete;
}(React.Component);

export default withStyles(styles, {
  name: 'AutoComplete'
})(AutoComplete);